import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';

@Component({
  selector: 'sales-ui-date-cell',
  template: `
    <span *ngIf="showDate" [matTooltip]="momentFormatDate(expiryDate, 'ddd MMM D YYYY')" class="tooltip-anchor">
      {{ fromNow }}
    </span>
    <span *ngIf="showExpired" [matTooltip]="momentFormatDate(expiryDate, 'ddd MMM D YYYY')" class="tooltip-anchor">
      {{ 'FRONTEND.SALES_UI.EXPIRED' | translate }}
    </span>
  `,
})
export class ExpiryCellComponent extends SalesOrderTableCustomComponentDirective implements OnInit {
  expiryDate: Date;
  fromNow: string;
  showDate = false;
  showExpired = false;

  ngOnInit(): void {
    if (this.element?.expiryDate) {
      const expiryMoment = moment(this.element?.expiryDate);
      this.expiryDate = expiryMoment.toDate();
      if (expiryMoment.isBefore(moment())) {
        this.showExpired = true;
      } else {
        this.fromNow = expiryMoment.fromNow();
        this.showDate = true;
      }
    }
  }

  momentFormatDate(date: Date, format: string): string {
    return moment(date).format(format);
  }
}
